import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { ArrowLeft } from 'lucide-react';

export default function DatenschutzPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center text-sm text-muted-foreground hover:text-primary transition-colors mb-8">
              <ArrowLeft className="w-4 h-4 mr-1" />
              Zurück zur Startseite
            </Link>

            <h1 className="font-heading font-bold text-4xl sm:text-5xl text-foreground mb-12">
              Datenschutz
            </h1>

            <div className="prose prose-lg max-w-none space-y-8 text-foreground">
              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">1. Allgemeine Hinweise</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie darüber, welche Daten wir erheben, wie wir diese nutzen und welche Rechte Sie in Bezug auf Ihre Daten haben.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">2. Verantwortlicher gemäß Art. 4 Abs. 7 DSGVO</h2>
                <p className="text-muted-foreground leading-relaxed">
                  DSG Beteiligungs- und Verwaltungsgesellschaft mbH
                </p>
                <p className="text-muted-foreground leading-relaxed mt-2">
                  Telefon:<br />
                  Mobil: +49 176 93127245<br />
                  Festnetz: +49 30 71047955
                </p>
                <p className="text-muted-foreground leading-relaxed mt-2">
                  E-Mail: info@battery-grid.io
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">3. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck der Verarbeitung</h2>

                <h3 className="font-heading font-semibold text-xl text-foreground mt-6 mb-3">3.1 Beim Besuch der Website</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an unseren Server gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert.
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Folgende Daten können dabei erfasst werden:
                </p>
                <ul className="list-disc list-inside text-muted-foreground leading-relaxed mt-2 space-y-1">
                  <li>IP-Adresse des anfragenden Geräts</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                  <li>Name und URL der abgerufenen Datei</li>
                  <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                  <li>verwendeter Browser und ggf. das Betriebssystem Ihres Endgeräts</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Diese Daten werden zu folgenden Zwecken verarbeitet:
                </p>
                <ul className="list-disc list-inside text-muted-foreground leading-relaxed mt-2 space-y-1">
                  <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
                  <li>Auswertung der Systemsicherheit und -stabilität</li>
                  <li>administrative Zwecke</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Rechtsgrundlage: Art. 6 Abs. 1 S. 1 lit. f DSGVO.
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Hosting erfolgt bei:
                </p>
                <p className="text-muted-foreground leading-relaxed mt-2">
                  STRATO AG<br />
                  Otto-Ostrowski-Straße 7<br />
                  10249 Berlin<br />
                  Deutschland
                </p>
                <p className="text-muted-foreground leading-relaxed mt-2">
                  Mit dem Hostinganbieter besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
                </p>

                <h3 className="font-heading font-semibold text-xl text-foreground mt-6 mb-3">3.2 Nutzung des Kontaktformulars</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular (Name, Firma, E-Mail-Adresse, Telefonnummer und Nachricht) zur Bearbeitung der Anfrage und für mögliche Anschlussfragen gespeichert.
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns.
                </p>

                <h3 className="font-heading font-semibold text-xl text-foreground mt-6 mb-3">3.3 Cookies</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Unsere Website verwendet ausschließlich technisch notwendige Cookies.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">4. Weitergabe von Daten</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Eine Übermittlung Ihrer persönlichen Daten an Dritte findet grundsätzlich nicht statt, außer wenn:
                </p>
                <ul className="list-disc list-inside text-muted-foreground leading-relaxed mt-2 space-y-1">
                  <li>Sie Ihre ausdrückliche Einwilligung erteilt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
                  <li>eine rechtliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
                  <li>die Verarbeitung zur Vertragserfüllung erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">5. Ihre Rechte als betroffene Person</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Sie haben folgende Rechte:
                </p>
                <ul className="list-disc list-inside text-muted-foreground leading-relaxed mt-2 space-y-1">
                  <li>Auskunft (Art. 15 DSGVO)</li>
                  <li>Berichtigung (Art. 16 DSGVO)</li>
                  <li>Löschung (Art. 17 DSGVO)</li>
                  <li>Einschränkung (Art. 18 DSGVO)</li>
                  <li>Widerspruch (Art. 21 DSGVO)</li>
                  <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Widerruf der Einwilligung: jederzeit möglich.
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Sie haben außerdem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">6. Speicherdauer</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">7. Datensicherheit</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Wir setzen geeignete technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust oder unbefugten Zugriff zu schützen.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">8. Änderungen dieser Datenschutzerklärung</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren.
                </p>
              </section>

              <p className="text-sm text-muted-foreground pt-8 border-t border-border">
                © 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
